import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TPVServices } from "../../services";
import { Subscription } from 'rxjs';
import { Globals } from '../../../../globals';
import { VariationsDishSelectorPage } from '../../../variations/variations-dish-selector/variations-dish-selector';
import { VariationsProductSelectorPage } from '../../../variations/variations-product-selector/variations-product-selector';
import { HttpParams, HttpClient } from '@angular/common/http';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the TpvTicketSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-ticket-select',
  templateUrl: 'tpv-ticket-select.html',
})
export class TpvTicketSelectPage {
  tag_selected_dish: any;
  tag_selected_product: any;
  subscription: Subscription;
  filteredElementsActive: boolean = false;
  filteredElements: any;
  max_dishes: any;
  max_ings_prods: any;
  max_menus: any;
  max_combo: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    private http: HttpClient) {

    this.max_dishes = this.globals.checkLimitsByLicense('dishes', 'max_dishes');
    this.max_ings_prods = this.globals.checkLimitsByLicense('stock', 'ings_prods');
    this.max_menus = this.globals.checkLimitsByLicense('daily_menu', 'limit');
    this.max_combo = this.globals.checkLimitsByLicense('daily_menu', 'limit_combo');

    if (this.max_dishes == -1) {
      this.max_dishes = undefined;
    }
    if (this.max_ings_prods == -1) {
      this.max_ings_prods = undefined;
    }
    if (this.max_menus == -1) {
      this.max_menus = undefined;
    }
    if (this.max_combo == -1) {
      this.max_combo = undefined;
    }
    //Dish
    this.subscription = this.tpvServices.getTagDish().subscribe(message => {
      this.tag_selected_dish = message;
      this.elementsNoVisibleDish();
      this.elementsVisibleDish();
    });
    //Product
    this.subscription = this.tpvServices.getTagProduct().subscribe(message => {
      this.tag_selected_product = message;
      this.elementsNoVisibleProduct();
      this.elementsVisibleProduct();
    });

  }

  elementsVisibleDish() {
    var elements = document.getElementsByClassName(this.tag_selected_dish.message) as HTMLCollectionOf<HTMLElement>;
    for (var i = 0, max = elements.length; i < max; i++) {
      elements[i].style.display = 'block';
    }
  }

  elementsNoVisibleDish() {
    var elements = document.getElementsByClassName('all') as HTMLCollectionOf<HTMLElement>;
    for (var i = 0, max = elements.length; i < max; i++) {
      elements[i].style.display = 'none';
    }
  }

  elementsVisibleProduct() {
    var elements = document.getElementsByClassName(this.tag_selected_product.message) as HTMLCollectionOf<HTMLElement>;
    for (var i = 0, max = elements.length; i < max; i++) {
      elements[i].style.display = 'block';
    }
  }

  elementsNoVisibleProduct() {
    var elements = document.getElementsByClassName('all') as HTMLCollectionOf<HTMLElement>;
    for (var i = 0, max = elements.length; i < max; i++) {
      elements[i].style.display = 'none';
    }
  }

  replaceTags(tags) {//Devuelve los elementos del array de tags como string i en minuscula
    if (tags) {
      tags = tags.toString().toLowerCase();
      return tags.replace(new RegExp(',', 'g'), ' ');
    }
  }

  insertToTicketProduct(product, _price, _delete, _count, _type, _uid) {

    //Comprovamos que el producto tenga el idioma seleccionado
    if (this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product)) {
      this.tpvServices.insertTable(this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product), _price, _delete, _count, _type, _uid, product);
    } else {//Si el producto no tiene nombre en el idioma seleccionado, pasamos un string
      this.tpvServices.insertTable('no name - ' + _price, _price, _delete, _count, _type, _uid, product);
    }


    this.tpvServices.autoScrollEnterElements();
  }

  insertToTicketMenu(_name, _price, _delete, _count, _type, _uid) {

    this.tpvServices.insertTable(_name, _price, _delete, _count, _type, _uid, {});

    this.tpvServices.autoScrollEnterElements();
  }

  insertToTicketDish(dish, _price, _delete, _count, _type, _uid) {

    //Comprovamos que el plato tenga el idioma seleccionado
    if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
      this.tpvServices.insertTable(this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish), _price, _delete, _count, _type, _uid, dish);
    } else {//Si el plato no tiene nombre en el idioma seleccionado, pasamos un string
      this.tpvServices.insertTable('no name - ' + _price, _price, _delete, _count, _type, _uid, dish);
    }

    if (this.globals.tour != '') {
      this.globals.tour_step_user = 5;
    }
    this.tpvServices.autoScrollEnterElements();
  }

  lp(_name, _price, _priceHalf, _priceTapa, _type, _uid) {

    this.navCtrl.push(VariationsDishSelectorPage, {
      name: _name,
      price: _price,
      price12: _priceHalf,
      priceTapa: _priceTapa,
      type: _type,
      uid: _uid,
      sender: 'tpv',
    });
    this.tpvServices.autoScrollEnterElements();
  }

  lpDish(dish, _price, _priceHalf, _priceTapa, _type, _uid) {

    //Comprovamos que el plato tenga el idioma seleccionado
    if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
      this.navCtrl.push(VariationsDishSelectorPage, {
        name: this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish),
        price: _price,
        price12: _priceHalf,
        priceTapa: _priceTapa,
        type: _type,
        uid: _uid,
        sender: 'tpv',
        tags: dish.tags,
      });
    } else {
      this.navCtrl.push(VariationsDishSelectorPage, {
        name: 'no name - ' + _price,
        price: _price,
        price12: _priceHalf,
        priceTapa: _priceTapa,
        type: _type,
        uid: _uid,
        sender: 'tpv',
        tags: dish.tags,
      });
    }
    this.tpvServices.autoScrollEnterElements();
  }

  variationProduct(product, pvp, pvp2, pvp3, _type, _uid) {
    if (!pvp2) {
      pvp2 = 0;
    }
    if (!pvp3) {
      pvp3 = 0;
    }

    //Comprovamos que el producto tenga el idioma seleccionado
    if (this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product)) {
      this.navCtrl.push(VariationsProductSelectorPage, {
        name: this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product),
        pvp: pvp,
        pvp2: pvp2,
        pvp3: pvp3,
        type: _type,
        uid: _uid,
        sender: 'tpv',
        tags: product.tags,
      });
    } else {
      this.navCtrl.push(VariationsProductSelectorPage, {
        name: 'no name - ' + pvp,
        pvp: pvp,
        pvp2: pvp2,
        pvp3: pvp3,
        type: _type,
        uid: _uid,
        sender: 'tpv',
        tags: product.tags,
      });
    }
    this.tpvServices.autoScrollEnterElements();
  }

  /*SEARCHER*/
  searchElementsNode(value) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredElementsActive = false;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('filter_string', value.target.value.toLowerCase());
        this.http.post(this.globals.analytics_path + 'filter/comandero', params, {})
          .subscribe(async res => {
            this.filteredElements = res;
            this.filteredElementsActive = true;
          });
      } else {
        this.filteredElementsActive = false;
      }
    }
  }

  openModalVersionPro() {
    this.navCtrl.push(AddonsTriggerVersionProPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-select/tpv-ticket-select.ts